@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.login

import com.narbase.letsgo.router.EndPoint

object UpdatePassengerDetailsEndpoint :
    EndPoint<UpdatePassengerDetailsEndpoint.Request, UpdatePassengerDetailsEndpoint.Response>() {
    class Request(
        val upsertDto: UpsertPassengerDetailsDto
    )

    class Response
}

class UpsertPassengerDetailsDto(
    val name: String,
    val email: String?,
    val isMale: Boolean,
    val isAndroid: Boolean,
    val fcmToken: String,
    var voipToken: String?,
    val isPhoneNumberVisible: Boolean,
)
